<i18n src="./resources/locales.json"></i18n>
<template>
  <div class="full-width">
    <div class="primary-title xtium-title">{{ $t('interfaceStyle') }}</div>
    <div class="d-flex flex-row justify-left my-3">
      <div class="d-flex align-center">
        <v-icon x-large>mdi-white-balance-sunny</v-icon>
      </div>
      <div class="theme-switch ml-5 mr-2 d-flex align-center">
        <v-switch
          hide-details
          :input-value="theme.darkMode"
          :disabled="disableControls"
          @change="onSwitchToggle"
        ></v-switch>
      </div>
      <div class="d-flex align-center">
        <v-icon x-large>mdi-moon-waxing-crescent</v-icon>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import EcsDisableControlsMixin from '@/mixins/EcsDisableControlsMixin';

export default {
  name: 'EcsInterfaceStyle',
  mixins: [EcsDisableControlsMixin],
  computed: {
    ...mapGetters(['theme'])
  },
  methods: {
    ...mapActions(['changeThemeMode']),
    onSwitchToggle(value) {
      this.changeThemeMode({ payload: value, vuetify: this.$vuetify });
    }
  }
};
</script>

<style>
.theme-switch {
  width: fit-content;
}
.theme-switch .v-input--selection-controls {
  margin-top: 0;
  padding-top: 0;
}
</style>
